/* eslint-disable */
import React, { memo, useMemo } from 'react';
import RocketSharpIcon from '@mui/icons-material/RocketSharp';
import StopCircleSharpIcon from '@mui/icons-material/StopCircleSharp';
import ConstructionIcon from '@mui/icons-material/Construction';
// import SmartToyIcon from '@mui/icons-material/SmartToy';
import ManageAccountsSharpIcon from '@mui/icons-material/ManageAccountsSharp';
import { Handle, NodeResizer, Position, useStore } from '@xyflow/react';
import { nodeStyles, handleStyles, nodeGroupButton } from './NodeStyles';
import AgentIcon from '../icons/AgentIcon';
import { DETACH, DETACH_FROM_GROUP, UN_GROUP, UN_GROUP_NODES } from '../constants/AgenticTextConstants';
import { Button } from '@mui/material';

const DetachButton = memo(({ selected, data, id }) => {
  return (
    <>
      {selected && data?.parentId && (
        <Button onClick={() => data?.onDetach(id)} title={DETACH_FROM_GROUP} style={nodeGroupButton.detachButton}>
          {DETACH}
        </Button>
      )}
    </>
  );
});

// Start Node component
export const StartNode = ({ data, selected }) => {
  const nodeStyle = {
    ...nodeStyles.base,
    ...nodeStyles.start,
    ...nodeStyles.startNodeBorder(selected)
    // border: selected ? '3px solid #fff' : '3px solid #4ade80'
  };
  const nodeTextStyle = { ...nodeStyles.nodesTextStyle };
  const handleStyle = { ...handleStyles.base, ...handleStyles.start, ...handleStyles.bottom };

  return (
    <>
      <div style={nodeStyle}>
        <Handle type="source" position={Position.Bottom} style={handleStyle} isConnectable={true} />
        <div style={nodeTextStyle}>{data.label || '__start__'}</div>

        {/* Rocket shape start icon */}
      </div>
    </>
  );
};

// End Node component
export const EndNode = memo(({ data, selected, theme, id }) => {
  const nodeStyle = useMemo(
    () => ({
      ...nodeStyles.base,
      ...nodeStyles.end,
      ...nodeStyles.endNodeBorder(selected)
      // border: selected ? `3px solid ${theme ? '#ffffff' : '#000000'}` : '3px solid #fb923c'
    }),
    [selected]
  );
  const nodeTextStyle = useMemo(() => ({ ...nodeStyles.nodesTextStyle }), []);
  const handleStyle = { ...handleStyles.base, ...handleStyles.end, ...handleStyles.top };
  const nodeIconPosition = useMemo(() => ({ ...nodeStyles.iconPosition }), []);

  return (
    <>
      <div style={nodeStyle}>
        <Handle type="target" position={Position.Top} style={handleStyle} isConnectable={true} id="top" />
        <div style={nodeTextStyle}>{data.label || '__end__'}</div>
      </div>
      <DetachButton selected={selected} data={data} id={id} />
    </>
  );
});

export const AgentNode = ({ data, id, selected }) => {
  const nodeStyle = {
    ...nodeStyles.base,
    ...nodeStyles.agent,
    ...nodeStyles.agentNodeBorder(selected)
    // border: selected ? '3px solid #fff' : '3px solid #a78bfa'
  };
  const nodeTextStyle = { ...nodeStyles.nodesTextStyle };
  const handleStyleTop = { ...handleStyles.base, ...handleStyles.agent, ...handleStyles.top };
  const handleStyleBottom = { ...handleStyles.base, ...handleStyles.agent, ...handleStyles.bottom };
  const handleStyleLeft = { ...handleStyles.base, ...handleStyles.agent, ...handleStyles.left };
  const handleStyleRight = { ...handleStyles.base, ...handleStyles.agent, ...handleStyles.right };

  // Handle double-click event
  const handleDoubleClick = () => {
    if (data.onNodeDoubleClick) {
      data.onNodeDoubleClick(id, 'agent', data);
    }
  };

  return (
    <>
      <div style={nodeStyle} onDoubleClick={handleDoubleClick}>
        {/* Top handle for incoming connections from start or other agents */}
        <Handle type="target" position={Position.Top} style={handleStyleTop} isConnectable={true} id="top" />
        <Handle type="target" position={Position.Right} style={handleStyleRight} isConnectable={true} id="right" />
        <Handle type="target" position={Position.Bottom} style={handleStyleBottom} isConnectable={true} id="bottom" />
        <Handle type="target" position={Position.Left} style={handleStyleLeft} isConnectable={true} id="left" />
        <div></div>
        {/* Top handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Top} style={handleStyleTop} isConnectable={true} id="top" />
        {/* Bottom handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Bottom} style={handleStyleBottom} isConnectable={true} id="bottom" />

        {/* Left handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Left} style={handleStyleLeft} isConnectable={true} id="left" />
        {/* Right handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Right} style={handleStyleRight} isConnectable={true} id="right" />
        <div style={nodeTextStyle}>{data.prompt || 'agent'}</div>
      </div>
    </>
  );
};

// Tool Node component
export const ToolNode = ({ data, id, selected }) => {
  const nodeStyle = {
    ...nodeStyles.base,
    ...nodeStyles.tool,
    ...nodeStyles.toolNodeBorder(selected)
    // border: selected ? '3px solid #fff' : '3px solid #fcd34d'
  };
  const nodeTextStyle = { ...nodeStyles.nodesTextStyle };
  const handleStyleTop = { ...handleStyles.base, ...handleStyles.tool, ...handleStyles.top };
  const handleStyleBottom = { ...handleStyles.base, ...handleStyles.tool, ...handleStyles.bottom };
  const handleStyleLeft = { ...handleStyles.base, ...handleStyles.tool, ...handleStyles.left };
  const handleStyleRight = { ...handleStyles.base, ...handleStyles.tool, ...handleStyles.right };

  // Handle double-click event
  const handleDoubleClick = () => {
    if (data.onNodeDoubleClick) {
      data.onNodeDoubleClick(id, 'tool', data);
    }
  };
  return (
    <>
      <div style={nodeStyle} onDoubleClick={handleDoubleClick}>
        <Handle type="target" position={Position.Top} style={handleStyleTop} isConnectable={true} id="top" />
        <Handle type="target" position={Position.Right} style={handleStyleRight} isConnectable={true} id="right" />
        <Handle type="target" position={Position.Bottom} style={handleStyleBottom} isConnectable={true} id="bottom" />
        <Handle type="target" position={Position.Left} style={handleStyleLeft} isConnectable={true} id="left" />
        <div>{/* Tool icon */}</div>
        {/* <Handle type="source" position={Position.Bottom} style={handleStyleBottom} isConnectable={true} /> */}

        {/* Side handles for more connection options */}
        {/* <Handle type="source" position={Position.Right} style={handleStyleRight} isConnectable={true} /> */}
        {/* <Handle type="target" position={Position.Left} style={handleStyleLeft} isConnectable={true} /> */}
        <div style={nodeTextStyle}>{data.tool_name || 'tools'}</div>
      </div>
    </>
  );
};

// Supervisor Node component
export const SupervisorNode = ({ data, id, selected }) => {
  const nodeStyle = {
    ...nodeStyles.base,
    ...nodeStyles.supervisor,
    ...nodeStyles.supervisorNodeBorder(selected)
    // border: selected ? '3px solid #fff' : '3px solid #eb6134'
  };
  const nodeTextStyle = { ...nodeStyles.nodesTextStyle };
  const handleStyleTop = { ...handleStyles.base, ...handleStyles.supervisor, ...handleStyles.top };
  const handleStyleBottom = { ...handleStyles.base, ...handleStyles.supervisor, ...handleStyles.bottom };
  const handleStyleLeft = { ...handleStyles.base, ...handleStyles.supervisor, ...handleStyles.left };
  const handleStyleRight = { ...handleStyles.base, ...handleStyles.supervisor, ...handleStyles.right };

  // Handle double-click event
  const handleDoubleClick = () => {
    if (data.onNodeDoubleClick) {
      data.onNodeDoubleClick(id, 'supervisor', data);
    }
  };
  return (
    <>
      <div style={nodeStyle} onDoubleClick={handleDoubleClick}>
        {/* Top handle for incoming connections from start */}
        <Handle type="target" position={Position.Top} style={handleStyleTop} isConnectable={true} id="top" />
        <div>{/* supervisor icon */}</div>
        {/* Bottom handle for outgoing connections to end */}
        <Handle type="source" position={Position.Bottom} style={handleStyleBottom} isConnectable={true} id="bottom" />

        {/* Left handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Left} style={handleStyleLeft} isConnectable={true} id="left" />
        {/* Right handle for outgoing connections to agents */}
        <Handle type="source" position={Position.Right} style={handleStyleRight} isConnectable={true} id="right" />
        <div style={nodeTextStyle}>{data.prompt || 'supervisor'}</div>
      </div>
    </>
  );
};

export const CustomGroup = React.memo((props) => {
  const { data, id, selected } = props;
  return (
    <>
      <NodeResizer isVisible={selected} minWidth={180} minHeight={100} />
      {selected && (
        <button onClick={() => data?.onDetach(id)} title={UN_GROUP_NODES} style={nodeGroupButton.ungroupButton}>
          {UN_GROUP}
        </button>
      )}
    </>
  );
});
